import request from '@/utils/request'
// 优惠劵添加
export function coupon_add(data) {
  return request({
    url: 'admin/coupon/add',
    method: 'post',
    data: data,
  })
}
// 优惠劵列表
export function coupon_list(data) {
  return request({
    url: 'admin/coupon/list',
    method: 'post',
    data: data,
  })
}
// 优惠劵详情
export function coupon_detail(data) {
  return request({
    url: 'admin/coupon/detail',
    method: 'post',
    data: data,
  })
}
// 优惠劵修改
export function coupon_update(data) {
  return request({
    url: 'admin/coupon/update',
    method: 'post',
    data: data,
  })
}
// 优惠劵删除
export function coupon_del(data) {
  return request({
    url: 'admin/coupon/del',
    method: 'post',
    data: data,
  })
}
// 优惠劵记录

export function coupon_select(data) {
  return request({
    url: 'admin/coupon/select',
    method: 'post',
    data: data,
  })
}
